import axios from 'axios';
import axiosInstance from '@/plugins/axios';

export default class ServiceDocumentos {
  static uploadUrl = (contentType, filename) =>
    axiosInstance.post('documentos/upload-url', { contentType, filename });
  static enviarArquivo = (url, file) =>
    axios.put(url, file, { headers: { 'Content-Type': file.type || 'application/octet-stream' } });
  static criar = (dados) => axiosInstance.post('documentos', dados);
  static listar = (filtros = {}, { page = 0, size = 50 } = {}) =>
    axiosInstance.get('documentos', { params: { ...filtros, page, size } });
  static downloadUrl = (id) => axiosInstance.get(`documentos/${id}/download-url`);
  static excluir = (id) => axiosInstance.delete(`documentos/${id}`);
}
